import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import Interactable from '../../../Component/Interactable';
import Game from '../../../Game';
import { StartAnimation } from '../../Animation/AnimationHelper';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { IRewardData } from '../../../Utility/RewardHelper';
import { RewardType } from '../../../Utility/Rewards/RewardType';
import BasePopupHandler from '../Menu/BasePopupHandler';
import ThreeStarItem from '../../../Prototype/UI/Popup/ThreeStarItem';
import UIItem, { ITextData, IImageData } from '../../../Prototype/UI/UIItem';
import Point from '../../../Utility/Point';
import { IButtonData } from '../../../Prototype/UI/BaseElements/Button';
import ButtonComponent from '../../../Component/UI/ButtonComponent';
import ElementComponent from '../../../Component/UI/Element';
import { Random } from '../../../Utility/Random';
import { AnimationClipEvent } from '../../Animation/AnimationClip';
import BaseUISystem from '../BaseUISystem';
import { IGameState } from '../../../State/Game/IGameState';
import { PopupID } from '../../../State/UI/PopupID';

// TODO: Move to own reward file
const REWARDS: Random.IWeightedItem<IRewardData>[] = [
    { odds: 0.15, data: { type: RewardType.COINS, value: 100 } },
    { odds: 0.33, data: { type: RewardType.COINS, value: 80 } },
    { odds: 0.19, data: { type: RewardType.COINS, value: 90 } },
    { odds: 0.1, data: { type: RewardType.COINS, value: 100 } },
    { odds: 0.11, data: { type: RewardType.COINS, value: 110 } },
    { odds: 0.12, data: { type: RewardType.COINS, value: 120 } },
];

export default class ThreeStarRewardMenuHandler extends BasePopupHandler {
    private lootBoxes: ThreeStarItem[];
    private coins: number = 0;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.THREE_STAR_REWARD_MENU, uiSystem);
    }
    protected onCreate() {
        super.onCreate();
        this.createPopup({
            relativePosition: new Point(0.07, 0),
        });
    }
    protected createPopup(params?: any): void {
        this.underlayParams.cacheKey = 'level_complete_underlay';
        this.underlayParams.layout.anchors = [0.5, 0.64, 0.5, 0.64];
        this.submitBtnBgParams.layout.anchors = [0.7, 0.88, 0.7, 0.88];
        this.submitBtnBgParams.cacheKey = 'blank';
        this.submitBtnParams.cacheKey = 'button_medium_green';

        super.createPopup(params);

        this.title = Game.locale.getText('3StarReward');
        this.popup.canClose = false;

        this.createChoices();
        this.popup.background.addChild(UIItem.createText(this.openPresentParams));
        this.popup.background.find(this.submitBtnBgParams.name).getComponent(Renderable).alpha = 0;

        const adBtn: GameObject = UIItem.createButton(this.adBtnParams);
        const adBtnBg: GameObject = UIItem.createImage(this.adBtnBgParams);

        adBtn.getComponent(ButtonComponent).onClick = this.onOpenAllClick.bind(this);
        adBtnBg.getComponent(Renderable).alpha = 0;

        adBtnBg.addChild(adBtn);
        this.popup.background.addChild(adBtnBg);
    }

    protected createChoices(): void {
        this.lootBoxes = [];
        const spacing: number = 0.27;
        for (let i = 0; i < 3; i++) {
            const xPos: number = 0.5 - spacing + i * spacing;
            const rewardItem = GameObject.Instantiate(ThreeStarItem, {
                onClick: this.openBox.bind(this, i),
                layout: {
                    anchors: [xPos, 0.5, xPos, 0.5],
                    scale: [1, 1],
                },
                index: i,
            });
            this.lootBoxes.push(rewardItem);
            this.popup.background.addChild(rewardItem);
        }
    }

    protected openBox(index: number): void {
        this.lootBoxes[index].reward = Random.getRandomWeighted(REWARDS);
        // Disable all boxes
        this.lootBoxes.forEach((lootBox: ThreeStarItem, boxIndex: number) => {
            if (boxIndex === index) {
                this.coins += lootBox.reward.value;
                lootBox.open();
            }
            lootBox.getComponentsInChildren(Interactable)[0].enabled = false;
        });

        const openedBoxes: ThreeStarItem[] = this.lootBoxes.filter((lootBox: ThreeStarItem) => {
            return lootBox.isOpen;
        });

        if (openedBoxes.length === 1) {
            // Fade out subtitle (Open a present).
            const openText: GameObject = this.popup.background.find(this.openPresentParams.name);
            StartAnimation(openText, 'Alpha', {
                startAlpha: 1,
                endAlpha: 0,
                duration: 500,
            });

            const submitBtn: GameObject = this.popup.background.find(this.submitBtnBgParams.name);
            const adBtn: GameObject = this.popup.background.find(this.adBtnBgParams.name);
            // Fade in buttons.
            StartAnimation(submitBtn, 'Alpha', {
                startAlpha: 0,
                endAlpha: 1,
                duration: 500,
                delay: 250,
            });
            StartAnimation(adBtn, 'Alpha', {
                startAlpha: 0,
                endAlpha: 1,
                duration: 500,
                delay: 250,
            });
        }
    }

    protected onOpenAllClick(): void {
        // TODO: Watch Ad
        this.lootBoxes.forEach((lootBox: ThreeStarItem) => {
            lootBox.reward = Random.getRandomWeighted(REWARDS);
            // TODO: Change to allow any reward type (ie use a IRewardData[])
            if (!lootBox.isOpen) {
                this.coins += lootBox.reward.value;
            }
            lootBox.open();
        });

        const submitBtn: GameObject = this.popup.background.find(this.submitBtnBgParams.name);
        const adBtn: GameObject = this.popup.background.find(this.adBtnBgParams.name);

        StartAnimation(submitBtn, 'Scale', {
            endScale: new Point(0, 0),
            duration: 250,
            delay: 250,
        }).on(AnimationClipEvent.COMPLETE, () => {
            submitBtn.getComponent(ElementComponent).layout.anchors = [0.5, 0.88, 0.5, 0.88];

            StartAnimation(submitBtn, 'Scale', {
                endScale: new Point(1, 1),
                duration: 250,
                delay: 250,
            });
        });

        StartAnimation(adBtn, 'Scale', {
            endScale: new Point(0, 0),
            duration: 250,
            delay: 250,
        }).on(AnimationClipEvent.COMPLETE, () => {
            adBtn.getComponent(Renderable).visible = false;
        });
    }

    // Base
    public handleStateChanged(state: IGameState) {
        super.handleStateChanged(state);
        /*
        // If completed advertisement open other gifts.
        if (
            state.context.response &&
            state.context.response.responseType ===
                ResponseType.DISPLAY_ADVERTISEMENT &&
            state.context.response.status === ResponseStatus.SUCCESS &&
            state.context.response.data.g_rewardType ===
                RewardType.THREE_STAR_REWARD
        ) {
            this.openOtherLootBoxes();
        }
        */
    }

    public onHide(params?: any): void {
        // Player receive coins.
        if (this.coins > 0) {
            PlayerActions.receiveRewards({
                rewards: [{ type: RewardType.COINS, value: this.coins }],
            });
            this.coins = 0;
        }
    }

    // Params -------------------------------------------------------------------------
    protected openPresentParams: ITextData = {
        name: 'openPresent',
        textLocalizationKey: 'OpenPresent',
        style: {
            font: 'FrancoisOne',
            fontSize: '35px',
            fill: '#bb3c2f',
        },
        layout: {
            anchors: [0.5, 0.28, 0.5, 0.28],
        },
    };
    protected adBtnParams: IButtonData = {
        name: 'ad_btn',
        cacheKey: 'button_medium_blue',
        layout: {
            anchors: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        textData: {
            name: 'ad_btn_text',
            textLocalizationKey: 'Openall',
            style: Game.style.getStyle('popup.dark_blue_btn'),
        },
    };
    protected adBtnBgParams: IImageData = {
        name: 'ad_btn_bg',
        layout: {
            anchors: [0.3, 0.88, 0.3, 0.88],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        cacheKey: 'blank',
    };
}
